import { TFilterBySyncChatSchema, TStatusSyncChatSchema } from '../../types/chatList';
import { ERoute, TRoute } from '../../types/route';

interface IGetQueryParamsFetchChatsListResponse {
  status: TStatusSyncChatSchema;
  filterBy: TFilterBySyncChatSchema;
}

export const getQueryParamsFetchChatsList = (currentRoute: TRoute): IGetQueryParamsFetchChatsListResponse => {
  let filterBy;
  let status;
  switch (currentRoute) {
    case ERoute.Messages:
      status = 'active';
      break;
    case ERoute.Archive:
      status = 'archived';
      break;
    case ERoute.Spam:
      status = 'blocked';
      break;
    case ERoute.Starred:
      filterBy = 'starred';
      status = 'active';
      break;
    case ERoute.Unread:
      filterBy = 'unread';
      status = 'active';
      break;
    default:
      status = 'active';
  }

  return { filterBy: filterBy as TFilterBySyncChatSchema, status: status as TStatusSyncChatSchema };
};
